import React from "react";
import { ToggleButton } from "./../../../ui-components/index.js";
import styles from "./list-item-toggle-scss.js";
const ListItemToggle = ({
  title,
  infoContent,
  dataHook,
  selected,
  onChange,
  disabled
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.container }, /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title,
      checked: selected,
      onChange,
      infoContent,
      dataHook,
      size: "small",
      disabled
    }
  ));
};
var ListItemToggle_default = ListItemToggle;
export {
  ListItemToggle_default as default
};
//# sourceMappingURL=ListItemToggle.js.map
